export const ENABLE_SAFEGUARDING_PAYLOAD_KEY = 'enableSafeguarding';
export const ENABLE_MEDICATION_FORMS_PAYLOAD_KEY = 'enableMedicationForms';
export const ENABLE_IMMUNIZATION_PAYLOAD_KEY = 'enableImmunization';
export const ENABLE_HEADCOUNTS_PAYLOAD_KEY = 'enableHeadcounts';
